import React, { useEffect } from "react";
import { useRecoilState } from "recoil";
import { userState } from "../../../states/userState";
import { User } from "../../../types";
import { setUserToLocalStorage } from "../../../utils/functions/localStorageManager";
import { Box } from "@mui/material";
import SingleInputMain from "../../singleInput/SingleInputMain";

const SingleInput = () => {
  const [user, setUser] = useRecoilState(userState);
  useEffect(() => {
    setUser((prevUser: User) => {
      const newUser: User = {
        ...prevUser,
        initialParameters: {
          ...prevUser.initialParameters,
          latestUrl: "/singleInput",
        },
      };
      setUserToLocalStorage(newUser);
      return newUser;
    });
  }, []);
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        width: "100%",
        alignItems: "center",
      }}
    >
      <SingleInputMain />
    </Box>
  );
};

export default SingleInput;
